import * as React from "react";
const SvgCloseGrey = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.50195 1.50098L10.502 10.501M10.502 1.50098L1.50195 10.501", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
}, strokeWidth: 1.4625, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgCloseGrey;
